import React from 'react';
import classNames from 'classnames';
import styles from './assets/seance-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { ISeance } from 'src/types/seance';

import { CellProps } from 'react-table';

import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';

import SeanceActionsColumn from './SeanceActionsColumn';
import SeanceCellColumn from './SeanceCellColumn';

import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import Loader from 'src/components/Loader';

interface Props {
    data: Paginated<ISeance>;

    stateData: any;
    inProgressSeance: boolean;
    setStateData: (data: any) => void;
}

const getColumns = (data: any, setData: any): Column<ISeance>[] => [
    {
        Header: '#',
        accessor: 'id', //occasion
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => original?.id,
        Filter: textFilter<ISeance>(),
    },
    {
        Header: 'Session Date',
        accessor: 'seanceDate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => changeToZeroMoment(original.seanceDate, 'MMM D, YYYY'),
        Filter: dateTimeFilter<ISeance>(),
    },
    {
        Header: 'Start Timer',
        accessor: 'startTime',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => changeToZeroMoment(original.startTime, 'LT'),
        disableSortBy: true,
        disableFilters: true,
        Filter: dateTimeFilter<ISeance>(),
    },
    {
        Header: 'End Time',
        accessor: 'endTime',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => changeToZeroMoment(original.endTime, 'LT'),
        disableSortBy: true,
        disableFilters: true,
        Filter: dateTimeFilter<ISeance>(),
    },
    {
        Header: 'Student',
        accessor: 'student',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => `${original?.student?.firstName} ${original?.student?.lastName}`,
        Filter: textFilter<ISeance>(),
    },
    {
        Header: 'External Rate Per Hour',
        accessor: 'externalRatePerHour',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => (
            <SeanceCellColumn name={'externalRatePerHour'} original={original} data={data} setData={setData} />
        ),
        Filter: textFilter<ISeance>(),
    },
    {
        Header: 'External EvalHourly Rate',
        accessor: 'externalEvalHourlyRate',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => (
            <SeanceCellColumn name={'externalEvalHourlyRate'} original={original} data={data} setData={setData} />
        ),
        Filter: textFilter<ISeance>(),
    },
    {
        Header: 'Internal Rate Per Hour',
        accessor: 'internalRatePerHour',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => (
            <SeanceCellColumn name={'internalRatePerHour'} original={original} data={data} setData={setData} />
        ),

        Filter: textFilter<ISeance>(),
    },
    {
        Header: 'Actions',
        accessor: 'isWeekly',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ISeance>) => <SeanceActionsColumn original={original} data={data} setData={setData} />,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const SeancesProviderGrid: React.FunctionComponent<Props> = ({
    data,
    inProgressSeance,
    stateData,
    setStateData,
}: Props) => {
    const columnData: Column<ISeance>[] = getColumns(stateData, setStateData);

    if (inProgressSeance) {
        return <Loader />;
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<ISeance> noLoader={true} columns={columnData} data={data} getData={() => false} />
        </div>
    );
};

export default SeancesProviderGrid;
